const MembershipLabelType = {
  Default: 0,
  GreenFeeLoyalty: 1,
  FlexibleAccess: 2,
};

// Full product name, e.g. "Flexible Membership at Three Cliffs".
const KEYS = {
  [MembershipLabelType.Default]: ['package.flexibleMembership', 'package.flexibleMembershipLower'],
  [MembershipLabelType.GreenFeeLoyalty]: ['package.greenFeeLoyaltyMembership', 'package.greenFeeLoyaltyMembershipLower'],
  [MembershipLabelType.FlexibleAccess]: ['package.flexibleAccess', 'package.flexibleAccessLower'],
};

// Bare noun that replaces the word "membership" inside a longer sentence,
// e.g. "Membership Refund Protection" -> "Flexible Access Refund Protection".
const TERM_KEYS = {
  [MembershipLabelType.Default]: ['package.membershipTerm', 'package.membershipTermLower'],
  [MembershipLabelType.GreenFeeLoyalty]: ['package.membershipTerm', 'package.membershipTermLower'],
  [MembershipLabelType.FlexibleAccess]: ['package.flexibleAccess', 'package.flexibleAccessLower'],
};

// Falls back to the legacy boolean when the enum is absent (old backend / cached payloads).
// 0 is a valid value, so presence is checked by type, not truthiness.
// Both property casings are accepted (PascalCase API contracts, camelCase pmg-services models).
function resolveMembershipLabelType(club) {
  if (!club) return MembershipLabelType.Default;

  const raw = typeof club.MembershipLabelType === 'number'
    ? club.MembershipLabelType
    : club.membershipLabelType;
  if (typeof raw === 'number' && KEYS[raw]) return raw;

  return (club.GreenFeeLoyaltyClub || club.greenFeeLoyaltyClub)
    ? MembershipLabelType.GreenFeeLoyalty
    : MembershipLabelType.Default;
}

// Registered globally in main.js, so every component can label wording without
// importing the mixin. Omitting `club` falls back to the club currently loaded
// into clubStore (home club, or the club being joined during checkout).
export default {
  methods: {
    $labelClub(club) {
      if (club) return club;
      return this.$store ? this.$store.getters.homeClubInfo : null;
    },
    $membershipLabel(club) {
      return this.$t(KEYS[resolveMembershipLabelType(this.$labelClub(club))][0]);
    },
    $membershipLabelLower(club) {
      return this.$t(KEYS[resolveMembershipLabelType(this.$labelClub(club))][1]);
    },
    $membershipTerm(club) {
      return this.$t(TERM_KEYS[resolveMembershipLabelType(this.$labelClub(club))][0]);
    },
    $membershipTermLower(club) {
      return this.$t(TERM_KEYS[resolveMembershipLabelType(this.$labelClub(club))][1]);
    },
    // For copy that lives outside a component and so cannot call the methods above
    // (route meta titles). A no-op for the Default and GreenFeeLoyalty types.
    $membershipInText(text, club) {
      if (!text) return text;
      return text
        .replace(/Membership/g, this.$membershipTerm(club))
        .replace(/membership/g, this.$membershipTermLower(club));
    },
    $isFlexibleAccessClub(club) {
      return resolveMembershipLabelType(this.$labelClub(club)) === MembershipLabelType.FlexibleAccess;
    },
  },
};

export { MembershipLabelType, resolveMembershipLabelType, TERM_KEYS };
